// extracted by mini-css-extract-plugin
var _1 = "Tags_active__58de4";
var _2 = "Tags_hint__3eb56";
var _3 = "Tags_menuItem__cd958";
var _4 = "Tags_root__f6702";
var _5 = "Tags_tabs__87cef";
var _6 = "Tags_tag__15737";
export { _1 as "active", _2 as "hint", _3 as "menuItem", _4 as "root", _5 as "tabs", _6 as "tag" }
